export type ResolveExportDocumentNameParams = {
  preferredName?: string | null;
  rawFileName?: string | null;
  fileExtension?: string | null;
  fallbackBaseName?: string;
};

export function resolveExportDocumentName({
  preferredName,
  rawFileName,
  fileExtension,
  fallbackBaseName = 'document',
}: ResolveExportDocumentNameParams): string {
  const normalizedPreferred = String(preferredName ?? '').trim();
  if (normalizedPreferred) {
    return normalizedPreferred;
  }

  const normalizedRawFileName = String(rawFileName ?? '').trim();
  if (normalizedRawFileName) {
    return normalizedRawFileName;
  }

  const normalizedExtension = String(fileExtension ?? '').trim().toLowerCase();
  if (normalizedExtension) {
    return `${fallbackBaseName}.${normalizedExtension}`;
  }

  return fallbackBaseName;
}
